import React, { useEffect, useState, useRef } from "react";
import { useDataProvider } from "../../api/DataProvider";
import "../../styles/devices/mob_SignDialog.css";
import Button from "@mui/material/Button";
import ReactPlayer from "react-player";
import VideocamIcon from '@mui/icons-material/Videocam';
import EmergencyRecordingIcon from '@mui/icons-material/EmergencyRecording';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { IconButton } from '@mui/material';
import { pDataProvider } from "../../utils/parameters";

import Paper from "@mui/material/Paper";
import { Tooltip, withStyles } from '@material-ui/core';

import Slider, { SliderThumb, SliderValueLabelProps } from "@mui/material/Slider";
import { styled } from "@mui/material/styles";

import ScoreBarComponent from '../utils/ScoreBarComponent';
import { Chip } from '@material-ui/core';
import { useTranslation } from "react-i18next";

import LiveHelpIcon from '@mui/icons-material/LiveHelp';

const SHOW_ORIGINAL = 0
const SHOW_OVERLAY = 1
const SHOW_KEYPOINTS = 2

export default function DialogInfo(props) {
  const { server_report_activity, user_vid_original, user_vid_keypoints, user_vid_overlay } = props;
  const { t } = useTranslation("global")
  
  const [ show_video, setShow_video ] = useState(SHOW_OVERLAY);
  const [ video_reference, setVideo_reference ] = useState(null)
  const [ video_user, setVideo_user ] = useState(null)

  const [ videoLoaded, setVideoLoaded ] = useState(false);
  const [ success, setSuccess ] = useState(true);
  const [ score, setScore ] = useState(50);
  const [ speedReduced, setSpeedReduced ] = useState(false);

  const playerRef = useRef(null);

  async function loadVideos() {

    if (show_video === SHOW_ORIGINAL) {
      setVideo_reference(user_vid_original);      
      setVideo_user(user_vid_original);  
    } 
    if (show_video === SHOW_OVERLAY) {
      setVideo_reference(user_vid_overlay);     
      setVideo_user(user_vid_overlay);  
    }
    if (show_video === SHOW_KEYPOINTS) {  
      setVideo_reference(user_vid_keypoints);      
      setVideo_user(user_vid_keypoints);  
    } 

    setSpeedReduced(false)
    
  }

  useEffect(() => {
    loadVideos();
  }, [user_vid_original, user_vid_overlay, user_vid_keypoints, show_video]);

  const handleScoreChange = (event, newValue) => {
    // Realiza las acciones necesarias con el nuevo valor
    setScore(newValue);
  };

  const handleEnded = () => {
    playerRef.current.seekTo(0); // Reiniciar el video al inicio
    setSpeedReduced(!speedReduced)
  };

  function showTutorial(){
    // console.log("🚀 ~ file: Teams.js:215 ~ showTutorial ~ showTutorial:", showTutorial)
    const URL = 'https://efficient-check-bb3.notion.site/C-mo-puedo-mejorar-mis-grabaciones-708e39d6764b4779a0263254cb400a8a'
    window.open(URL, "_blank", "noopener,noreferrer");
  }
  

  return (
    <>
      <div className='sig_SignModal_CarouselContainer'>
      <div className="sig_Hub_InfoTitle sig_Hub_InfoSubTitle sig_VersusMachine_ResultsTop">

        {show_video === SHOW_ORIGINAL ? 
          <>
            <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_ORIGINAL)} disabled={show_video === SHOW_ORIGINAL} > 
            <VideocamIcon fontSize="small" color={(show_video == SHOW_ORIGINAL) ? 'disabled' : 'primary'}/> 
            </IconButton>
          </> : 
          <>
            <Tooltip title={t("sTooltip.show_original")} placement="bottom" arrow>
              <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_ORIGINAL)} disabled={show_video === SHOW_ORIGINAL} > 
                <VideocamIcon fontSize="small" color={(show_video == SHOW_ORIGINAL) ? 'disabled' : 'primary'}/> 
              </IconButton>
            </Tooltip>
          </>
        } 
        {show_video === SHOW_OVERLAY ? 
          <>
            <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_OVERLAY)} disabled={show_video === SHOW_OVERLAY} > 
            <EmergencyRecordingIcon fontSize="small" color={(show_video == SHOW_OVERLAY) ? 'disabled' : 'primary'}/> 
            </IconButton>
          </> : 
          <>
            <Tooltip title={t("sTooltip.show_overlay")} placement="bottom" arrow>
              <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_OVERLAY)} disabled={show_video === SHOW_OVERLAY} > 
                <EmergencyRecordingIcon fontSize="small" color={(show_video == SHOW_OVERLAY) ? 'disabled' : 'primary'}/> 
              </IconButton>
            </Tooltip>
          </>
        } 
        {show_video === SHOW_KEYPOINTS ? 
          <>
            <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_KEYPOINTS)} disabled={show_video === SHOW_KEYPOINTS} > 
            <MyLocationIcon fontSize="small" color={(show_video == SHOW_KEYPOINTS) ? 'disabled' : 'primary'}/> 
            </IconButton>
          </> : 
          <>
            <Tooltip title={t("sTooltip.show_keypoints")} placement="bottom" arrow>
              <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_KEYPOINTS)} disabled={show_video === SHOW_KEYPOINTS} > 
                <MyLocationIcon fontSize="small" color={(show_video == SHOW_KEYPOINTS) ? 'disabled' : 'primary'}/> 
              </IconButton>
            </Tooltip>
          </>
        } 
      </div>
      </div>

      <div>
          <Chip
              style={{position: "absolute", backgroundColor: "#5ea0d4"}}
              label={ (speedReduced)?' DESPACIO ':' NORMAL ' }
              size="medium" color="secondary"
          />

        <ReactPlayer 
          ref={playerRef}
          width="80%" 
          height="80%" 
          className="sig_VersusMachine_videoDetailDialog" 
          url={ video_user } 
          controls={false} 
          playing={true} 
          loop={false}
          playbackRate={ (speedReduced) ? 0.5 : 1 }
          onEnded={handleEnded}
        />

      </div>



      <div className="sig_SignModal_Sign">
        <Paper className="sig_VersusMachine_PaperInfo">
          <div className="sig_SignModal_PaperInfo">
            <div className="sig_SignModal_PaperLine">
              <span className="sig_VersusMachine_InfoTitle"> {t("sMoveYourSkeleton.score_position_kps")} </span>
            </div>
                <ScoreBarComponent value={server_report_activity['actual_score'] === undefined ? server_report_activity : server_report_activity['actual_score']} />
          </div>
        </Paper>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom:'10px' }}>
        <Button className="sig_SignDialog_Button" style={{ backgroundColor:'#026bbc', marginTop: '5px', maxWidth: '90%', borderRadius:'10px' }} onClick={showTutorial} variant="contained">
          <LiveHelpIcon className="sig_Collab_UndoIcon" /> 
          <span className="sig_Collab_Teams_ReturnButton_Label">¿Como mejorar las grabaciones?</span>
        </Button>
      </div>
    </>
  );
}
